const config = {
    API_ENDPOINT: 'https://radiant-sands-56161.herokuapp.com/api',
    TOKEN_KEY: 'shelf-life-client-auth-token',
    API_KEY: process.env.REACT_APP_API_KEY,
};

export default config;